<template>
  <div
    class="flex justify-center items-center w-full h-full text-primary flex-col"
    style="font-size: 56px"
  >
    <AppLoading />
    <span class="type-scale-3 text-gray-80 pt-4" v-if="$slots.default"
      ><slot
    /></span>
  </div>
</template>

<script>
export default {
  name: 'AppLoadingScreen'
}
</script>
